<div class="container mb-100" [formGroup]="commPrefsForm">
  <div class="header-title-container">
    <p><adp-label labelKey="Account_Communication_Preferences_Heading"></adp-label></p>
  </div>
  <mat-divider class="divider"></mat-divider>

  <div class="mt-20 mb-20 row">
    <div class="col-10 desktop-view">
      <div class="comm-prefs-desc comm-prefs-subheading">
        <adp-label labelKey="Account_Communication_Preferences_Subheading"></adp-label>
      </div>
      <div class="mt-20 comm-prefs-desc">
        <adp-label labelKey="Account_Communication_Preferences_Description"></adp-label>
      </div>
    </div>
    <div class="col-2 desktop-view slide-toggle">
      <div>
        <adp-label labelKey="Account_Communication_Preferences_SlideToggle"></adp-label>
      </div>
      <mat-slide-toggle color="primary" formControlName="SmsConsent" [sf-aria-label]="'Account_Communication_Preferences_SlideToggle'">
      </mat-slide-toggle>
    </div>

    <div class="mobile-view">
      <div class="comm-prefs-desc comm-prefs-subheading">
        <adp-label labelKey="Account_Communication_Preferences_Subheading"></adp-label>
      </div>
      <div class="mt-20 comm-prefs-desc">
        <adp-label labelKey="Account_Communication_Preferences_Description"></adp-label>
      </div>
    </div>
    <div class="row mobile-view">
      <div class="col-6">
        <adp-label labelKey="Account_Communication_Preferences_SlideToggle"></adp-label>
      </div>
      <div class="col-6" style="text-align: right">
        <mat-slide-toggle color="primary" formControlName="SmsConsent" [sf-aria-label]="'Account_Communication_Preferences_SlideToggle'">
        </mat-slide-toggle>
      </div>
    </div>
  </div>
  <mat-divider class="divider"></mat-divider>

  <div class="mt-20 mb-20">
    <div class="mt-20 comm-prefs-desc comm-prefs-subheading">
      <adp-label labelKey="Account_Communication_Preferences_Language_Subheading"></adp-label>
    </div>
    <div class="mt-20 comm-prefs-desc">
      <adp-label labelKey="Account_Communication_Preferences_Language_Description"></adp-label>
    </div>
    <div class="mt-20 comm-prefs-language">
      <adp-select
        [resourceData]="getResource('Account_Communication_Preferences_Languages')"
        formControlName="Languages"
        [sf-aria-label]="'Account_Communication_Preferences_Language_Subheading'"
        [listItems]="languages"></adp-select>
    </div>
    <div class="mt-20 comm-prefs-desc">
      <button
        mat-flat-button
        color="accent"
        class="comm-button"
        (click)="onSaveClicked()"
        [disabled]="commPrefsForm.pristine || isSaving"
        [gtmClick]="getViewLabel('Global_Button_SaveChanges')">
        <adp-label labelKey="Global_Button_SaveChanges"></adp-label>
      </button>
    </div>
  </div>
</div>
